<div class="mat-mdc-form-field-error-wrapper relative">
  <span class="mat-mdc-form-field-error">{{ error }}</span>
</div>
